import React from 'react';
import PrintableLayout from './PrintableLayout.jsx';
import venuePhoto from '../../assets/images/sofia-alexandra/sofia-venue-aquatico-resort.webp';
import logicaLogo from '../../assets/images/Logica (Black and White).webp';
import { QRCodeSVG } from 'qrcode.react';
import sofiaImage1 from '../../assets/images/sofia-alexandra/sofia-images-1.webp';
import sofiaImage2 from '../../assets/images/sofia-alexandra/sofia-images-2.webp';
import sofiaImage3 from '../../assets/images/sofia-alexandra/sofia-images-3.webp';
import sofiaImage4 from '../../assets/images/sofia-alexandra/sofia-images-4.webp';
import sofiaImage5 from '../../assets/images/sofia-alexandra/sofia-images-5.webp';
import sofiaHeroPhoto from '../../assets/images/sofia-alexandra/sofia-alexandra-hero-image.webp';
import sofiaEnchantedOverlay from '../../assets/images/sofia-alexandra/sofia-enchanted-hero-overlay.webp';
import sofiaDressCode from '../../assets/images/sofia-alexandra/sofia-dress-code-inspiration.webp';
import sofiaCardBg from '../../assets/images/sofia-alexandra/sofia-card-enchanted-bg.webp';
import sofiaImage10 from '../../assets/images/sofia-alexandra/sofia-images-10.webp';
import sofiaImage7 from '../../assets/images/sofia-alexandra/sofia-images-7.webp';
import sofiaImage8 from '../../assets/images/sofia-alexandra/sofia-images-8.webp';
import sofiaImage9 from '../../assets/images/sofia-alexandra/sofia-images-9.webp';
import '../../styles/JenineCharissePrintable.css';

const ROSES = [
  'Nico Gorordo', 'Jerome Angeles', 'Andrew Angeles', 'Darelle Torrijos',
  'Rovin Mueco', 'JC Angeles', 'Jestoni Angeles', 'Vic Angeles',
  'Joey Sanchez', 'Kyle Sianosa', 'Kenneth Dano', 'Humphrey Manguiat',
  'Emmanuel Soriano', 'Amiel Agrisola', 'Jayr Magnayi', 'Albert Esteban',
  'Ricardo Gorordo', 'Reinerio Soco',
];
const CANDLES = [
  'Rihance Amping', 'Christa Galias', 'Yakisha Olarte', 'Haliana Mahiya',
  'Zujin Hernandez', 'Breya Debil', 'Aneah Nuestro', 'Kate Mediavillo',
  'Raiza Tapia', 'Chezka Calamlam', 'Kyle Arana', 'Leo Cabling',
  'Porziah Mendoza', 'Rianna De Jesus', 'Lyndel Lacuata', 'Leslei Lacho',
  'Nicole Tindoc', 'Jorelyn Angeles',
];
const GIFTS = [
  'Rhian Limosinero', 'Daena Torrijos', 'Nicole Mueco', 'Dennise Mueco',
  'Angel Angeles', 'Chynnalyn Caro', 'Sophia Montuya', 'Vanessa Vanguardia',
  'Alex Nervaez', 'Isabelle Alinas', 'Nicole Acantilado', 'Jolan Malapitan',
  'Lexine Regaspi', 'Marchella Maniclang', 'Marie Mahiya', 'Rebecca Relucio',
  'Sofia Guttierez', 'Jenelle Saplaco',
];
const SHOTS = [
  'Ayesha Aala', 'Mirah Lorbes', 'Sebastian Manibo', 'Kathleen Centeno',
  'Raizen Baluyot', 'Charles Cacao', 'Aryann Fazon', 'Harvey Mansalapuz',
  'Kim Soriano', 'Irah Granado', 'Albert Esteban', 'Loreine Valdez',
  'Jairus Senario', 'Adrienne Sabado', 'Denise Aguisanda', 'Khaye Matundan',
  'Chloe Magtagnob', 'Kyle Agrisola',
];
const BLUE_BILLS = [
  'Grace Gorordo', 'Eva David', 'Cecile Soco', 'Maria Liza Angeles',
  'Antonette Alzona', 'Toni Rose Mancilla', 'Haydee Booy', 'Bea Therese Gorordo',
  'Regine Alzona', 'Tin Gorordo', 'Judy Nonog', 'Aida Sanchez',
  'Ivy Galias', 'Norie Dano', 'Hennie Limosinero', 'Oly Garcia',
  'Kayvin Soco', 'Roselle Velasco',
];
const PROGRAM = [
  'Opening Prayer',
  'Opening Spiel',
  'Introduction to the Family',
  'Intro Video',
  'Opening Production of the Celebrant',
  'Growing Up Video',
  'Games',
  'Opening Remarks',
  'Re-Entrance',
  '18 Roses',
  '18 Shots',
  'Intermission Number',
  'Games',
  'Re-Entrance',
  '18 Bills',
  '18 Candles',
  "Mother's Speech",
  'Blowing of Cake / Birthday Song',
  'Photo Opportunity',
  'Dinner',
  'Games',
  'Message of the Celebrant',
  'Closing Spiel',
  'Grand Photo Opportunity',
  'After Party',
];

const TRADITION_DESC = {
  roses: 'Eighteen men who will each present a rose to Sofia Alexandra, symbolizing admiration, respect, and heartfelt wishes for her journey into womanhood.',
  candles: 'Eighteen meaningful lights from loved ones who illuminate her path forward, each carrying a wish and a prayer for the celebrant.',
  gifts: 'Eighteen generous souls who bring their love wrapped in thoughtful gifts, each one a symbol of care and celebration for Sofia Alexandra.',
  shots: 'Eighteen toasts from eighteen special people, each raising a glass to celebrate Sofia Alexandra and wish her a life full of joy, love, and adventure.',
  blueBills: 'Eighteen tokens of generosity and prosperity, representing blessings and heartfelt support from the special women who have shaped her life.',
};

const cardBgStyle = {
  backgroundImage: [
    'linear-gradient(180deg, rgba(253,255,254,0.80) 0%, rgba(244,250,245,0.74) 100%)',
    `url(${sofiaCardBg})`,
    'linear-gradient(160deg, #FDFFFE 0%, #F4FAF5 100%)',
  ].join(', '),
  backgroundSize: 'auto, cover, auto',
  backgroundPosition: 'center, center, center',
  backgroundRepeat: 'no-repeat, no-repeat, no-repeat',
  border: '1.5px solid rgba(201,168,68,0.35)',
};

const Divider = () => (
  <div className="pl-divider" aria-hidden="true">
    <div className="pl-divider-line" />
    <div className="pl-divider-diamond" />
    <div className="pl-divider-line" />
  </div>
);

const SectionHeader = ({ kicker, heading }) => (
  <div style={{ textAlign: 'center', marginBottom: '4mm' }}>
    <span className="pl-section-kicker">{kicker}</span>
    <h2 className="pl-section-heading">{heading}</h2>
    <Divider />
  </div>
);

const TradList = ({ icon, label, desc, names, style }) => (
  <div className="pl-trad-panel" style={style}>
    <span className="pl-trad-icon" aria-hidden="true">{icon}</span>
    <h3 className="pl-trad-heading">{label}</h3>
    <p className="pl-trad-desc">{desc}</p>
    <ul className="pl-trad-list" aria-label={`${label} participants`}>
      {names.map((name, index) => (
        <li key={index} className="pl-trad-item">
          <span className="pl-trad-num">{index + 1}.</span>
          {name}
        </li>
      ))}
    </ul>
  </div>
);

export default function SofiaAlexandraPrintable() {
  return (
    <PrintableLayout
      title="Sofia Alexandra — Printable Invitation (13 pages)"
      filename="sofia-alexandra-debut-invitation"
    >
      <article
        className="pl-page pl-cover"
        aria-label="Cover page"
        style={{
          backgroundImage: [
            'linear-gradient(90deg, rgba(5,20,13,0.18) 0%, rgba(5,20,13,0.36) 46%, rgba(5,20,13,0.76) 100%)',
            'linear-gradient(180deg, rgba(13,43,30,0.10) 0%, rgba(13,43,30,0.74) 100%)',
            `url(${sofiaHeroPhoto})`,
            'linear-gradient(160deg, #012212 0%, #1B4332 35%, #081C15 70%, #012212 100%)',
          ].join(', '),
          backgroundSize: 'auto, auto, cover, auto',
          backgroundPosition: 'center, center, center, center',
          backgroundRepeat: 'no-repeat, no-repeat, no-repeat, no-repeat',
        }}
      >
        {/* Enchanted forest overlay — mirrors .sa-hero-overlay from the digital invitation */}
        <div
          aria-hidden="true"
          style={{
            position: 'absolute',
            inset: 0,
            zIndex: 1,
            backgroundImage: [
              'radial-gradient(ellipse 42% 50% at 68% 48%, rgba(5,20,13,0.60) 0%, rgba(5,20,13,0.24) 52%, transparent 76%)',
              'radial-gradient(ellipse 80% 60% at 50% 0%, rgba(116,198,157,0.10) 0%, transparent 60%)',
              'radial-gradient(ellipse 50% 40% at 84% 78%, rgba(201,168,68,0.08) 0%, transparent 50%)',
              `url(${sofiaEnchantedOverlay})`,
            ].join(', '),
            backgroundSize: 'auto, auto, auto, cover',
            backgroundPosition: 'center, center, center, center',
            backgroundRepeat: 'no-repeat, no-repeat, no-repeat, no-repeat',
            opacity: 0.88,
            pointerEvents: 'none',
          }}
        />
        {/* Bottom canopy fade — mirrors .sa-hero-canopy */}
        <div
          aria-hidden="true"
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '35%',
            background: 'linear-gradient(180deg, transparent 0%, rgba(13,43,30,0.65) 100%)',
            zIndex: 2,
            pointerEvents: 'none',
          }}
        />
        <div className="pl-cover-frame" aria-hidden="true" />
        <div className="pl-cover-text">
          <span className="pl-cover-invite-tag">You are warmly invited to celebrate</span>
          <h1 className="pl-cover-hero-name">Sofia Alexandra</h1>
          <p className="pl-cover-hero-turns">Turns Eighteen</p>
          <p className="pl-cover-hero-theme">✦ &ensp; An Enchanted Forest Debut &ensp; ✦</p>
          <div className="pl-cover-hero-divider" aria-hidden="true">
            <div className="pl-cover-hero-divider-line" />
            <div className="pl-cover-hero-divider-diamond" />
            <div className="pl-cover-hero-divider-line" />
          </div>
          <p className="pl-cover-hero-meta">Saturday &nbsp;·&nbsp; July 4, 2026 &nbsp;·&nbsp; 4:30 PM</p>
          <p className="pl-cover-hero-venue">Aquatico Royale Resort, Calamba, Laguna</p>
          <p className="pl-cover-hero-hosted">Hosted with love by Leah Angeles</p>
        </div>
      </article>

      <article className="pl-page pl-page-welcome-details" aria-label="Welcome and details">
        <div className="pl-content">
          <SectionHeader kicker="A message from the heart" heading="Dear Beloved Guests," />

          <p className="pl-body-text">
            With hearts brimming with joy and gratitude, we invite you to witness a once-in-a-lifetime
            milestone, the blossoming of a remarkable young woman into all she is beautifully destined to be.
          </p>
          <p className="pl-body-text">
            <strong>Sofia Alexandra</strong> is turning eighteen, and on this enchanted evening beneath the
            forest canopy, we celebrate not merely a birthday, but the beginning of a radiant new chapter,
            a story woven in grace, in laughter, and in love that will last a lifetime.
          </p>

          <div className="pl-body-quote">
            "She walks in beauty, like the night<br />
            of cloudless climes and starry skies,<br />
            and in her smile, the forest breathes."
          </div>

          <p className="pl-body-text">
            You have been chosen to be part of this magical evening, not merely as a witness, but as a
            cherished soul whose warmth, prayers, and well-wishes mean everything to her and to our family.
          </p>

          <p className="pl-body-text" style={{ textAlign: 'center', marginTop: '2mm', marginBottom: '0.5mm' }}>
            With all our love,
          </p>
          <p
            style={{
              margin: '0 auto 0',
              textAlign: 'center',
              fontSize: '11pt',
              color: 'var(--pl-dark)',
              fontStyle: 'italic',
              fontFamily: 'var(--pl-serif)',
            }}
          >
            Leah Angeles
          </p>

          <div className="pl-details-box" style={cardBgStyle}>
            <h3 className="pl-details-box-title">✦ &ensp; Celebration Details &ensp; ✦</h3>
            <div className="pl-details-grid">
              <div>
                <span className="pl-detail-label">Date</span>
                <span className="pl-detail-value">Saturday, July 4, 2026</span>
              </div>
              <div>
                <span className="pl-detail-label">Time</span>
                <span className="pl-detail-value">4:30 PM</span>
              </div>
              <div>
                <span className="pl-detail-label">Venue</span>
                <span className="pl-detail-value">Aquatico Royale Resort</span>
              </div>
              <div>
                <span className="pl-detail-label">Theme</span>
                <span className="pl-detail-value">Enchanted Forest</span>
              </div>
            </div>
            <div className="pl-family-row">
              <div className="pl-family-person">
                <span className="pl-family-role">Mother</span>
                <span className="pl-family-name">Leah Angeles</span>
              </div>
            </div>
          </div>
        </div>
      </article>

      <article className="pl-page" aria-label="Glimpse of the celebrant">
        <div className="pl-content">
          <SectionHeader kicker="A glimpse of the celebrant" heading="Sofia In Bloom" />
          <div className="pl-photogallery-grid">
            <div className="pl-photogallery-cell"><div className="pl-photo-bg" style={{ backgroundImage: `url(${sofiaImage1})` }} /></div>
            <div className="pl-photogallery-cell"><div className="pl-photo-bg" style={{ backgroundImage: `url(${sofiaImage9})` }} /></div>
            <div className="pl-photogallery-cell"><div className="pl-photo-bg" style={{ backgroundImage: `url(${sofiaImage2})` }} /></div>
            <div className="pl-photogallery-cell"><div className="pl-photo-bg" style={{ backgroundImage: `url(${sofiaImage3})` }} /></div>
          </div>
        </div>
      </article>

      <article className="pl-page pl-page-dress-reminders" aria-label="Dress code and guest instructions">
        <div className="pl-content">
          <SectionHeader kicker="Everything you need to know" heading="Dress Code & Guest Reminders" />

          <div className="pl-two-col" style={{ flex: 1 }}>
            <div className="pl-panel" style={cardBgStyle}>
              <span className="pl-panel-kicker">Dress for the enchanted forest</span>
              <h3 className="pl-panel-heading">Dress Code</h3>
              <Divider />
              <img src={sofiaDressCode} alt="Dress code inspiration" className="pl-dresscode-img" />
              <p className="pl-dresscode-body">
                Guests are warmly invited to dress in their finest semi-formal wear. Embrace the occasion
                with elegant <strong>black attire</strong> befitting this magical evening.
              </p>
              <p className="pl-dresscode-body">
                <strong>Please come in black and avoid green or silver attire</strong> so the celebrant remains the focal point of the evening.
              </p>
              <div className="pl-pills">
                <span className="pl-pill pl-pill-ladies">Ladies — Semi-Formal Dress</span>
                <span className="pl-pill pl-pill-gents">Gentlemen — Semi-Formal</span>
                <span className="pl-pill pl-pill-avoid">Avoid — Green &amp; Silver</span>
              </div>
            </div>

            <div className="pl-panel" style={cardBgStyle}>
              <span className="pl-panel-kicker">A kind request from the family</span>
              <h3 className="pl-panel-heading">Special Instructions</h3>
              <Divider />
              <ul className="pl-instr-list">
                <li className="pl-instr-item">
                  <span className="pl-instr-num">1</span>
                  <p className="pl-instr-text">
                    <strong>Upon arrival</strong> — A coordinator will assist you at the entrance. A grazing
                    table and photobooth will be available throughout the evening.
                  </p>
                </li>
                <li className="pl-instr-item">
                  <span className="pl-instr-num">2</span>
                  <p className="pl-instr-text">
                    <strong>Drop a letter</strong> — Bring a handwritten note to place in the letter box at the coordinator's
                    table. Sofia Alexandra will treasure every heartfelt message she receives.
                  </p>
                </li>
                <li className="pl-instr-item">
                  <span className="pl-instr-num">3</span>
                  <p className="pl-instr-text">
                    <strong>18 Candles, 18 Shots &amp; 18 Bills participants</strong> — Please prepare a short birthday
                    message, read it when your name is called, and then place your letter in the same box.
                  </p>
                </li>
                <li className="pl-instr-item">
                  <span className="pl-instr-num">4</span>
                  <p className="pl-instr-text">
                    <strong>Share the memories</strong> — Take as many photos and videos as you like and send them to the
                    Facebook account <strong>"Obina Leah."</strong>
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </article>

      <article className="pl-page" aria-label="18 Roses and 18 Candles">
        <div className="pl-content">
          <SectionHeader kicker="A debut full of tradition" heading="Special Traditions — Part 1" />
          <div className="pl-trad-cols">
            <TradList icon="🌹" label="18 Roses" desc={TRADITION_DESC.roses} names={ROSES} style={cardBgStyle} />
            <TradList icon="🕯️" label="18 Candles" desc={TRADITION_DESC.candles} names={CANDLES} style={cardBgStyle} />
          </div>
        </div>
      </article>

      <article className="pl-page" aria-label="18 Gifts and 18 Shots">
        <div className="pl-content">
          <SectionHeader kicker="A debut full of tradition" heading="Special Traditions — Part 2" />
          <div className="pl-trad-cols">
            <TradList icon="🎁" label="18 Gifts" desc={TRADITION_DESC.gifts} names={GIFTS} style={cardBgStyle} />
            <TradList icon="🥂" label="18 Shots" desc={TRADITION_DESC.shots} names={SHOTS} style={cardBgStyle} />
          </div>
        </div>
      </article>

      <article className="pl-page" aria-label="18 Blue Bills and participant reminders">
        <div className="pl-content">
          <SectionHeader kicker="A debut full of tradition" heading="Special Traditions — Part 3" />
          <div className="pl-two-col" style={{ flex: 1 }}>
            <TradList icon="💵" label="18 Blue Bills" desc={TRADITION_DESC.blueBills} names={BLUE_BILLS} style={cardBgStyle} />
            <div className="pl-panel" style={cardBgStyle}>
              <span className="pl-panel-kicker">For those taking part in the program</span>
              <h3 className="pl-panel-heading">Participant Notes</h3>
              <Divider />
              <ul className="pl-instr-list">
                <li className="pl-instr-item">
                  <span className="pl-instr-num">1</span>
                  <p className="pl-instr-text">
                    <strong>Prepare a short birthday message</strong> and write it in a letter you can read aloud
                    once your name is called.
                  </p>
                </li>
                <li className="pl-instr-item">
                  <span className="pl-instr-num">2</span>
                  <p className="pl-instr-text">
                    <strong>Coordinate with the event team</strong> upon arrival so you know when to standby for your
                    segment during the program.
                  </p>
                </li>
                <li className="pl-instr-item">
                  <span className="pl-instr-num">3</span>
                  <p className="pl-instr-text">
                    <strong>Keep your note</strong> after reading so you can place it in the letter box and leave Sofia
                    Alexandra a keepsake from the evening.
                  </p>
                </li>
                <li className="pl-instr-item">
                  <span className="pl-instr-num">4</span>
                  <p className="pl-instr-text">
                    <strong>Enjoy the celebration</strong> — your presence, your blessing, and your kind words are part
                    of what make this debut unforgettable.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </article>

      <article className="pl-page pl-program-bg" aria-label="Program flow">
        <div className="pl-content">
          <SectionHeader kicker="The evening's schedule" heading="Program Flow" />
          <div className="pl-program-card" style={cardBgStyle}>
            <ol className="pl-program-list">
              {PROGRAM.map((item, index) => (
                <li key={index} className="pl-program-item">
                  <span className="pl-program-num">{index + 1}.</span>
                  <span>{item}</span>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </article>

      <article className="pl-page pl-page-venue-gift" aria-label="Venue, gift guide, and closing">
        <div className="pl-content">
          <SectionHeader kicker="Find your way to the celebration" heading="The Venue" />

          <img src={venuePhoto} alt="Aquatico Royale Resort" className="pl-venue-photo" />
          <h3 className="pl-venue-name">Aquatico Royale Resort</h3>
          <p className="pl-venue-meta">Purok 6 Spring Villas, Bucal, Calamba, Laguna</p>
          <p className="pl-venue-note">✦ &ensp; Parking is available within the resort premises</p>

          <Divider />

          <div style={{ textAlign: 'center', marginBottom: '2mm' }}>
            <span className="pl-section-kicker">A note from the celebrant</span>
            <h3 className="pl-section-heading" style={{ fontSize: '13pt' }}>Gift Guide</h3>
          </div>

          <div className="pl-gift-quote">
            "Your presence at my debut is the most precious gift I could ever receive. If you feel comfortable
            giving more, a heartfelt contribution to my future journey would be deeply appreciated."
          </div>
          <p className="pl-gift-sig">— Sofia Alexandra</p>

          <div className="pl-closing">
            <span className="pl-closing-tag">✦ &ensp; See you in the enchanted forest &ensp; ✦</span>
            <p
              style={{
                margin: '1mm auto',
                textAlign: 'center',
                fontSize: '16pt',
                color: 'var(--pl-dark)',
                fontFamily: 'var(--pl-serif)',
                fontStyle: 'italic',
              }}
            >
              Sofia Alexandra
            </p>
            <p className="pl-closing-text">Saturday · July 4, 2026 · 4:30 PM · Aquatico Royale Resort</p>
          </div>
        </div>
      </article>

      <article className="pl-page pl-page-gallery-part-1" aria-label="Photo gallery part 1">
        <div className="pl-content">
          <SectionHeader kicker="More moments to cherish" heading="Photo Gallery" />
          <div className="pl-photogallery-2up">
            <div className="pl-photogallery-cell"><div className="pl-photo-bg" style={{ backgroundImage: `url(${sofiaImage5})` }} /></div>
            <div className="pl-photogallery-cell pl-gallery2-cell--sofia-focus"><div className="pl-photo-bg" style={{ backgroundImage: `url(${sofiaImage10})` }} /></div>
          </div>
        </div>
      </article>

      <article className="pl-page" aria-label="Photo gallery part 2">
        <div className="pl-content">
          <SectionHeader kicker="More moments to cherish" heading="Photo Gallery" />
          <div className="pl-photogallery-2up pl-photogallery-2up--side-by-side">
            <div className="pl-photogallery-cell"><div className="pl-photo-bg" style={{ backgroundImage: `url(${sofiaImage8})` }} /></div>
            <div className="pl-photogallery-cell"><div className="pl-photo-bg" style={{ backgroundImage: `url(${sofiaImage7})` }} /></div>
          </div>
        </div>
      </article>

      <article className="pl-page pl-qr-page" aria-label="Invitation QR code">
        <div className="pl-qr-inner">
          <span className="pl-qr-kicker">You're invited</span>
          <h2 className="pl-qr-heading">Scan to View the Digital Invitation</h2>
          <div className="pl-qr-divider" aria-hidden="true">
            <div className="pl-qr-divider-line" />
            <div className="pl-qr-divider-diamond" />
            <div className="pl-qr-divider-line" />
          </div>
          <div className="pl-qr-code-wrap">
            <QRCodeSVG
              value="https://e-invitation.online/invitations/custom/sofia-alexandra-debut"
              size={160}
              bgColor="transparent"
              fgColor="#3a2c22"
              level="M"
            />
          </div>
          <p className="pl-qr-url">e-invitation.online/invitations/custom/sofia-alexandra-debut</p>
          <p className="pl-qr-desc">
            Scan the QR code to open the interactive invitation, submit your RSVP, review event details,
            and check your seat reservation from your phone.
          </p>
        </div>
      </article>

      <article className="pl-page pl-thankyou-page" aria-label="Thank you and closing">
        <div className="pl-thankyou-inner">
          <p
            className="pl-thankyou-script"
            style={{
              margin: '0 auto 2mm',
              textAlign: 'center',
              fontSize: '18pt',
              color: 'rgba(253,248,240,0.92)',
              fontFamily: 'var(--pl-serif)',
              fontStyle: 'italic',
            }}
          >
            Sofia Alexandra
          </p>
          <p className="pl-thankyou-turns">Turns Eighteen &nbsp;·&nbsp; July 4, 2026</p>
          <p className="pl-thankyou-message">
            Thank you for being one of the cherished souls invited to witness this enchanted celebration.
            Your love, your laughter, and your presence mean everything to us, and we cannot wait to celebrate
            with you in the forest of dreams.
          </p>
          <hr className="pl-thankyou-divider" aria-hidden="true" />
          <p className="pl-thankyou-credit">✦ &nbsp; An Enchanted Forest Debut</p>
          <div className="pl-thankyou-watermark">
            <p>Created with ❤️ by</p>
            <img src={logicaLogo} alt="Logica Technology" className="pl-thankyou-logo" />
          </div>
        </div>
      </article>
    </PrintableLayout>
  );
}